var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1994 1904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efeff4;}.cls-2{opacity:0.75;}.cls-3{fill:#c6c9d3;}.cls-12,.cls-15,.cls-33,.cls-4,.cls-7{fill:#fff;}.cls-4{opacity:0.54;}.cls-5{opacity:0.87;}.cls-6{fill:#d7d9e0;}.cls-7{opacity:0.47;}.cls-8{fill:#18174a;}.cls-9{fill:#2b69b3;}.cls-10{fill:#5c5e61;}.cls-11{fill:#a8abb2;}.cls-13{fill:#74767b;}.cls-14,.cls-15{opacity:0.8;}.cls-16{fill:#333435;}.cls-17{fill:#48494b;}.cls-18{fill:url(#linear-gradient);}.cls-19{fill:url(#linear-gradient-2);}.cls-20{fill:url(#linear-gradient-3);}.cls-21{fill:url(#linear-gradient-4);}.cls-22{fill:url(#linear-gradient-5);}.cls-23{fill:#e8e8ef;}.cls-24{fill:url(#linear-gradient-6);}.cls-25{fill:url(#linear-gradient-7);}.cls-26{fill:url(#linear-gradient-8);}.cls-27{fill:url(#linear-gradient-9);}.cls-28{fill:url(#linear-gradient-10);}.cls-29{fill:#ecc538;}.cls-30{fill:url(#linear-gradient-11);}.cls-31{fill:#f7eba6;}.cls-32{fill:url(#linear-gradient-12);}.cls-33{opacity:0.85;}.cls-34{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 121.29,
    y1: 1727.62,
    x2: 113.92,
    y2: 1748.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efeff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 301.31,
    y1: 1735.47,
    x2: 300.74,
    y2: 1755.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5407.79,
    y1: 1304.88,
    x2: -5539.63,
    y2: 1475.33,
    gradientTransform: "translate(5771.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bcc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9bcc5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 803.26,
    y1: 768.34,
    x2: 859.98,
    y2: 718.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 347.47,
    y1: 1050.82,
    x2: 425.97,
    y2: 821.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 70.63,
    y1: 1186.92,
    x2: 545.68,
    y2: 1186.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 108,
    y1: 1206.66,
    x2: -170.44,
    y2: 978.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 343.95,
    y1: 728.9,
    x2: 198.81,
    y2: 432.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 311.43,
    y1: 744.83,
    x2: 166.29,
    y2: 448.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 744.7,
    y1: 701.79,
    x2: 801.42,
    y2: 651.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1130.09,
    y1: 271.84,
    x2: 1492.38,
    y2: 271.84,
    gradientTransform: "translate(5.43 -25) rotate(1.09)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1477.86,
    y1: 1172.29,
    x2: 1816.47,
    y2: 1172.29,
    gradientTransform: "translate(142.52 -178.06) rotate(6.47)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1415.38,
    y1: 641.04,
    x2: 1819.42,
    y2: 641.04,
    gradientTransform: "translate(82.49 -178.09) rotate(6.47)",
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1686.44,1627.06c-37.77,39.3-73.51,64.65-101.76,84.67-332,235.41-724.75,166.79-808.23,150C653.18,1837,414.9,1789.18,242.62,1589-18,1286,22.57,808.78,224.74,493.73c37-57.62,232.31-377.46,629.34-428.75,240.27-31.05,520.36,31.56,723.19,199.51C2003,617,1972.71,1329.2,1686.44,1627.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1839.82,733.89C1713,836.73,1409.25,1153.58,1411.14,1828.7c0,0,543-428.13,490.73-1068.14C1899.37,729.92,1863.7,714.53,1839.82,733.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1805.4,913.22c-3,17.91-6.58,35.41-10.3,53s-7.71,35-11.93,52.46q-12.62,52.29-27.71,103.9c-20.17,68.77-43.32,136.68-70.25,203.07-6.61,16.65-13.74,33.09-20.78,49.56l-11,24.5c-1.86,4.08-3.64,8.19-5.56,12.23l-5.77,12.13c-3.9,8.06-7.58,16.23-11.66,24.2l-12.08,24c-4,8-8.37,15.82-12.54,23.75l-6.32,11.85c-2.14,3.92-4.39,7.8-6.58,11.7l-13.25,23.36-13.84,23c-4.52,7.73-9.44,15.21-14.26,22.75l-7.24,11.31-3.62,5.65-3.79,5.54-15.16,22.16c-2.47,3.73-5.17,7.3-7.81,10.92l-7.94,10.82-7.93,10.83c-2.64,3.61-5.5,7-8.24,10.59l-16.61,21.09a1.2,1.2,0,0,1-1.68.19,1.19,1.19,0,0,1-.21-1.66l0,0,16.24-21.28c2.68-3.57,5.48-7,8.06-10.69l7.75-10.91,7.75-10.92c2.57-3.64,5.21-7.24,7.62-11l14.78-22.32,3.68-5.58,3.53-5.69,7-11.37c4.69-7.59,9.48-15.12,13.87-22.89l13.44-23.14,12.85-23.47c2.12-3.92,4.3-7.81,6.37-11.75l6.12-11.9c4-8,8.24-15.82,12.13-23.84l11.66-24.08c4-8,7.49-16.19,11.25-24.27l5.56-12.16c1.85-4.06,3.56-8.18,5.35-12.26L1657,1372c6.76-16.51,13.6-33,19.93-49.64a2136.06,2136.06,0,0,0,66.84-203.13q14.23-51.54,26-103.7,5.89-26.06,11.06-52.26c3.42-17.43,6.69-35,9.37-52.41v-.12a7.69,7.69,0,1,1,15.2,2.35S1805.4,913.2,1805.4,913.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1907,345.06c4.31-8.62-5.82-16.23-14.64-11.05-89.52,52.65-314.54,216.51-358.64,553.29-55.32,422.55-188.92,560.35-329.76,635.84,0,0,171.3-20.32,312.56-159.33C1863.34,1022.51,1830.25,498.35,1907,345.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1816.37,467.06c-6.25,7.79-11.9,16.31-17.48,24.71S1788,508.88,1783,517.7c-5.24,8.68-9.83,17.73-14.69,26.61s-9.07,18.14-13.61,27.19c-17.62,36.51-32.49,74.3-45.64,112.63-13.41,38.25-24.1,77.4-34.16,116.64l-6.66,29.66L1665,845.27l-1.66,7.41c-.51,2.48-.94,5-1.41,7.47L1656.35,890c-1.86,10-3.66,19.89-5.69,30A1155.76,1155.76,0,0,1,1580,1155.25c-15.83,37.8-33.1,75-52.33,111.19l-14.76,27c-5.11,8.89-10.18,17.79-15.42,26.6-10.52,17.65-21.34,34.91-33.25,52a7.69,7.69,0,0,1-12.69-8.69l.12-.18c5.51-8.19,11-16.76,16.27-25.36s10.48-17.28,15.63-26,10-17.58,15-26.39l14.33-26.76c18.88-35.8,36-72.55,51.52-109.9l5.79-14c1.93-4.68,3.9-9.34,5.61-14.1l10.74-28.38c.89-2.37,1.83-4.71,2.67-7.1l2.44-7.18,4.88-14.36c3.19-9.59,6.71-19.09,9.42-28.83l8.66-29.07c.7-2.43,1.49-4.83,2.11-7.28l1.85-7.35,3.72-14.7,3.71-14.7,1.86-7.35c.55-2.46,1-5,1.54-7.42l6.07-29.7,12.16-60c.52-2.51,1-5,1.54-7.52l1.79-7.46,3.59-14.92,7.2-29.83,8.24-29.57,4.12-14.78c1.36-4.93,3.05-9.77,4.56-14.66l9.3-29.25c3.28-9.69,6.93-19.26,10.38-28.89,14.22-38.36,30.17-76.13,48.87-112.54,4.89-9,9.58-18.09,14.64-27,5.21-8.82,10.14-17.78,15.72-26.37,10.81-17.39,22.29-34.3,35.67-50a2.06,2.06,0,0,1,3.18,2.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1079.9,1437S792.73,1327.91,718.53,986.22C646.41,654.1,628.6,184.73,219.72,69c-13.77-3.9-26.31,9.54-20.21,21.66,36.06,71.7,121.77,259.33,144.7,463.71C373.49,815.28,584.38,1425.45,1079.9,1437Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M327.47,180.51l1.51.83,1.25.75c.82.49,1.62,1,2.38,1.49,1.56,1,3.07,2,4.55,3,3,2,5.92,4.13,8.76,6.29,5.76,4.27,11.26,8.81,16.65,13.46A398.72,398.72,0,0,1,393.15,236a422.44,422.44,0,0,1,27.27,32.65c8.63,11.26,16.39,23.13,24,35.09a507.83,507.83,0,0,1,38,75.82,536.67,536.67,0,0,1,25,80.91,643.32,643.32,0,0,1,13,83.5l1.63,21,.85,21.09c.32,7.08.47,13.87.7,20.81l.33,10.36c.11,3.45.37,6.9.54,10.35,1.3,27.62,4,55.17,7.41,82.62s8,54.78,13.31,82a1192.55,1192.55,0,0,0,43.58,160.25c9,26.21,19.22,52,30.1,77.48s23.1,50.42,36,75c26.1,48.92,56.23,95.8,91.15,139l6.58,8.08,3.28,4,3.43,3.92,13.73,15.67,14.29,15.16c2.35,2.56,4.83,5,7.32,7.42l7.43,7.3a608.25,608.25,0,0,0,63.66,53.83,608.6,608.6,0,0,1-65-52.41l-7.64-7.15c-2.55-2.37-5.1-4.75-7.51-7.27L771,1277.6l-14.16-15.41-3.53-3.85-3.4-4-6.8-8c-36.22-42.5-67.3-89.24-94.52-138-13.44-24.48-26.16-49.39-37.65-74.87-3-6.31-5.62-12.79-8.45-19.18l-4.18-9.61L594.33,995c-2.6-6.49-5.29-12.94-7.81-19.45l-7.37-19.63a1203.87,1203.87,0,0,1-46.21-161.18c-5.75-27.37-10.85-54.91-14.6-82.66s-6.94-55.59-8.65-83.56c-.23-3.5-.53-7-.7-10.49l-.47-10.5-1-20.91-1-20.62-1.74-20.56a626.9,626.9,0,0,0-13.31-81.27c-12.54-53.4-32.86-105-61.37-151.64a457.64,457.64,0,0,0-49.06-65.46,383.78,383.78,0,0,0-29-28.72c-5.11-4.48-10.31-8.86-15.66-13-2.65-2.09-5.37-4.09-8.09-6-1.37-1-2.74-1.92-4.1-2.81-.69-.47-1.37-.9-2-1.31l-1-.61-.76-.45-.58-.34a7.68,7.68,0,0,1,7.61-13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.83,301.78c-4.95-10.93,8.3-21.29,19.14-15C188,350.31,462.84,550.86,498.75,984.26,543.81,1528,704.59,1699.51,878.17,1790c0,0-215.34-17.61-385.72-190.26C74.14,1175.84,146.81,496.17,58.83,301.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M169.84,451.85C186,472,199.63,493.77,212.3,516.08l4.8,8.33c1.55,2.81,3,5.66,4.53,8.49l9,17c5.76,11.45,11.25,23,16.86,34.57,21.44,46.6,39.12,94.84,54.57,143.72C318,777,329.53,827,340.73,877l7.15,37.78,3.58,18.89,1.78,9.45,1.45,9.5,5.77,38c1.91,12.66,3.89,25.39,5.62,37.9l2.72,18.84,3.13,18.78,1.57,9.39,1.77,9.35,3.57,18.7c5.14,24.86,10.63,49.66,17.1,74.22,12.6,49.2,28.14,97.61,45.42,145.38q26.26,71.52,59,140.46c10.89,22.95,22.26,45.67,34.3,68q9,16.78,18.49,33.27c6.29,11,12.8,22,19.48,32.45l.1.15a7.69,7.69,0,0,1-12.92,8.34c-14.25-21.8-27-43.93-39.36-66.5s-24-45.4-35.18-68.52c-22.25-46.27-42.06-93.69-59.82-141.86a1463.31,1463.31,0,0,1-45.38-147.15c-6.4-24.87-11.81-50-16.86-75.17l-3.5-18.94-1.74-9.48-1.53-9.51-3.06-19-2.64-19.09L340.3,954.91,339,945.46l-1.66-9.39L334,917.28l-6.61-37.59-8-37.3c-2.69-12.44-5.17-24.92-8.49-37.2l-9.37-37c-1.46-6.2-3.37-12.26-5.1-18.38l-5.31-18.32c-14.36-48.78-31-97-51.31-143.62-5.26-11.57-10.39-23.22-15.81-34.72l-8.49-17.08c-1.42-2.84-2.8-5.71-4.27-8.53l-4.54-8.39c-3.07-5.56-5.95-11.24-9.18-16.71L187.86,486c-6.75-10.72-13.51-21.61-21.19-31.54l-.07-.09a2.06,2.06,0,0,1,3.24-2.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 496.54,
    y: 54,
    width: 707.07,
    height: 1739.41,
    rx: 22.79,
    transform: "translate(1700.16 1847.41) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 725.73,
    y: 54,
    width: 707.07,
    height: 1739.41,
    rx: 36.12,
    transform: "translate(2158.54 1847.41) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M773,275.39V173.49c0-20,12.27-36.3,27.36-36.3h540.49c15.09,0,27.37,16.28,27.37,36.3v101.9c0,20-12.28,36.3-27.37,36.3H800.39C785.3,311.69,773,295.41,773,275.39Zm27.36-129.13c-11.32,0-20.52,12.21-20.52,27.23v101.9c0,15,9.2,27.23,20.52,27.23h540.49c11.32,0,20.53-12.22,20.53-27.23V173.49c0-15-9.21-27.23-20.53-27.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M773,554.6V452.69c0-20,12.27-36.3,27.36-36.3h540.49c15.09,0,27.37,16.28,27.37,36.3V554.6c0,20-12.28,36.29-27.37,36.29H800.39C785.3,590.89,773,574.61,773,554.6Zm27.36-129.13c-11.32,0-20.52,12.21-20.52,27.22V554.6c0,15,9.2,27.22,20.52,27.22h540.49c11.32,0,20.53-12.21,20.53-27.22V452.69c0-15-9.21-27.22-20.53-27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M773,850.93V749c0-20,12.27-36.3,27.36-36.3h540.49c15.09,0,27.37,16.29,27.37,36.3V850.93c0,20-12.28,36.29-27.37,36.29H800.39C785.3,887.22,773,870.94,773,850.93ZM800.39,721.8c-11.32,0-20.52,12.21-20.52,27.22V850.93c0,15,9.2,27.22,20.52,27.22h540.49c11.32,0,20.53-12.21,20.53-27.22V749c0-15-9.21-27.22-20.53-27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M773,1130.13V1028.22c0-20,12.27-36.29,27.36-36.29h540.49c15.09,0,27.37,16.28,27.37,36.29v101.91c0,20-12.28,36.3-27.37,36.3H800.39C785.3,1166.43,773,1150.14,773,1130.13ZM800.39,1001c-11.32,0-20.52,12.21-20.52,27.22v101.91c0,15,9.2,27.22,20.52,27.22h540.49c11.32,0,20.53-12.21,20.53-27.22V1028.22c0-15-9.21-27.22-20.53-27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M776.45,1416.5V1314.6c0-20,12.27-36.3,27.36-36.3H1344.3c15.09,0,27.37,16.28,27.37,36.3v101.9c0,20-12.28,36.3-27.37,36.3H803.81C788.72,1452.8,776.45,1436.52,776.45,1416.5Zm27.36-129.13c-11.31,0-20.52,12.22-20.52,27.23v101.9c0,15,9.21,27.23,20.52,27.23H1344.3c11.32,0,20.53-12.21,20.53-27.23V1314.6c0-15-9.21-27.23-20.53-27.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M773,1702.45V1600.54c0-20,12.27-36.3,27.36-36.3h540.49c15.09,0,27.37,16.28,27.37,36.3v101.91c0,20-12.28,36.29-27.37,36.29H800.39C785.3,1738.74,773,1722.46,773,1702.45Zm27.36-129.13c-11.32,0-20.52,12.21-20.52,27.22v101.91c0,15,9.2,27.22,20.52,27.22h540.49c11.32,0,20.53-12.21,20.53-27.22V1600.54c0-15-9.21-27.22-20.53-27.22Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1324.35,
    cy: 220.95,
    rx: 13.11,
    ry: 12.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1324.35,
    cy: 503.64,
    rx: 13.11,
    ry: 12.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1324.35,
    cy: 794.77,
    rx: 13.11,
    ry: 12.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1324.35,
    cy: 1079.18,
    rx: 13.11,
    ry: 12.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1324.35,
    cy: 1365.55,
    rx: 13.11,
    ry: 12.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1330.05,
    cy: 1651.49,
    rx: 13.11,
    ry: 12.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1243.08,
    y: 1648.62,
    width: 21.55,
    height: 77.39,
    transform: "translate(2507.7 3374.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1207.08,
    y: 1675.22,
    width: 21.55,
    height: 50.79,
    transform: "translate(2435.7 3401.23) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1171.07,
    y: 1609.49,
    width: 21.55,
    height: 116.52,
    transform: "translate(2363.7 3335.5) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1135.07,
    y: 1698.02,
    width: 21.55,
    height: 27.99,
    transform: "translate(2291.69 3424.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1099.07,
    y: 1625.07,
    width: 21.55,
    height: 100.94,
    transform: "translate(2219.69 3351.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1063.07,
    y: 1642.54,
    width: 21.55,
    height: 83.47,
    transform: "translate(2147.68 3368.56) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1027.07,
    y: 1661.54,
    width: 21.55,
    height: 64.47,
    transform: "translate(2075.68 3387.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 991.06,
    y: 1585.93,
    width: 21.55,
    height: 140.08,
    transform: "translate(2003.68 3311.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 955.06,
    y: 1600.75,
    width: 21.55,
    height: 125.26,
    transform: "translate(1931.67 3326.76) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 919.06,
    y: 1623.17,
    width: 21.55,
    height: 102.84,
    transform: "translate(1859.67 3349.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 883.06,
    y: 1700.62,
    width: 21.55,
    height: 25.4,
    transform: "translate(1787.66 3426.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 847.06,
    y: 1651.28,
    width: 21.55,
    height: 74.73,
    transform: "translate(1715.66 3377.29) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1242.5,
    y: 1358.2,
    width: 21.55,
    height: 77.39,
    transform: "translate(2506.54 2793.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1206.5,
    y: 1384.8,
    width: 21.55,
    height: 50.79,
    transform: "translate(2434.54 2820.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1170.49,
    y: 1319.07,
    width: 21.55,
    height: 116.52,
    transform: "translate(2362.54 2754.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1134.49,
    y: 1407.6,
    width: 21.55,
    height: 27.99,
    transform: "translate(2290.53 2843.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1098.49,
    y: 1334.65,
    width: 21.55,
    height: 100.94,
    transform: "translate(2218.53 2770.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1062.49,
    y: 1352.12,
    width: 21.55,
    height: 83.47,
    transform: "translate(2146.52 2787.71) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1026.49,
    y: 1371.12,
    width: 21.55,
    height: 64.47,
    transform: "translate(2074.52 2806.71) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 990.48,
    y: 1295.51,
    width: 21.55,
    height: 140.08,
    transform: "translate(2002.52 2731.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 954.48,
    y: 1310.33,
    width: 21.55,
    height: 125.26,
    transform: "translate(1930.51 2745.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 918.48,
    y: 1332.75,
    width: 21.55,
    height: 102.84,
    transform: "translate(1858.51 2768.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 882.48,
    y: 1410.2,
    width: 21.55,
    height: 25.4,
    transform: "translate(1786.5 2845.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 846.48,
    y: 1360.86,
    width: 21.55,
    height: 74.73,
    transform: "translate(1714.5 2796.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1250.02,
    y: 1072.99,
    width: 21.55,
    height: 77.39,
    transform: "translate(2521.58 2223.36) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1214.01,
    y: 1099.58,
    width: 21.55,
    height: 50.79,
    transform: "translate(2449.58 2249.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1178.01,
    y: 1033.85,
    width: 21.55,
    height: 116.52,
    transform: "translate(2377.57 2184.23) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1142.01,
    y: 1122.38,
    width: 21.55,
    height: 27.99,
    transform: "translate(2305.57 2272.76) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1106.01,
    y: 1049.43,
    width: 21.55,
    height: 100.94,
    transform: "translate(2233.56 2199.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1070.01,
    y: 1066.91,
    width: 21.55,
    height: 83.47,
    transform: "translate(2161.56 2217.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1034,
    y: 1085.91,
    width: 21.55,
    height: 64.47,
    transform: "translate(2089.56 2236.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 998,
    y: 1010.29,
    width: 21.55,
    height: 140.08,
    transform: "translate(2017.55 2160.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 962,
    y: 1025.11,
    width: 21.55,
    height: 125.26,
    transform: "translate(1945.55 2175.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 926,
    y: 1047.53,
    width: 21.55,
    height: 102.84,
    transform: "translate(1873.54 2197.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 890,
    y: 1124.98,
    width: 21.55,
    height: 25.4,
    transform: "translate(1801.54 2275.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 853.99,
    y: 1075.65,
    width: 21.55,
    height: 74.73,
    transform: "translate(1729.54 2226.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1249.44,
    y: 792.98,
    width: 21.55,
    height: 77.39,
    transform: "translate(2520.42 1663.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1213.43,
    y: 819.57,
    width: 21.55,
    height: 50.79,
    transform: "translate(2448.42 1689.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1177.43,
    y: 753.84,
    width: 21.55,
    height: 116.52,
    transform: "translate(2376.41 1624.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1141.43,
    y: 842.37,
    width: 21.55,
    height: 27.99,
    transform: "translate(2304.41 1712.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1105.43,
    y: 769.42,
    width: 21.55,
    height: 100.94,
    transform: "translate(2232.4 1639.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1069.43,
    y: 786.9,
    width: 21.55,
    height: 83.47,
    transform: "translate(2160.4 1657.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1033.42,
    y: 805.89,
    width: 21.55,
    height: 64.47,
    transform: "translate(2088.4 1676.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 997.42,
    y: 730.28,
    width: 21.55,
    height: 140.08,
    transform: "translate(2016.39 1600.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.42,
    y: 745.1,
    width: 21.55,
    height: 125.26,
    transform: "translate(1944.39 1615.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 925.42,
    y: 767.52,
    width: 21.55,
    height: 102.84,
    transform: "translate(1872.38 1637.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 889.42,
    y: 844.97,
    width: 21.55,
    height: 25.4,
    transform: "translate(1800.38 1715.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 853.42,
    y: 795.64,
    width: 21.55,
    height: 74.73,
    transform: "translate(1728.38 1666) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1250.02,
    y: 498.05,
    width: 21.55,
    height: 77.39,
    transform: "translate(2521.58 1073.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1214.01,
    y: 524.64,
    width: 21.55,
    height: 50.79,
    transform: "translate(2449.58 1100.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1178.01,
    y: 458.91,
    width: 21.55,
    height: 116.52,
    transform: "translate(2377.57 1034.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1142.01,
    y: 547.44,
    width: 21.55,
    height: 27.99,
    transform: "translate(2305.57 1122.87) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1106.01,
    y: 474.49,
    width: 21.55,
    height: 100.94,
    transform: "translate(2233.56 1049.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1070.01,
    y: 491.97,
    width: 21.55,
    height: 83.47,
    transform: "translate(2161.56 1067.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1034,
    y: 510.96,
    width: 21.55,
    height: 64.47,
    transform: "translate(2089.56 1086.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 998,
    y: 435.35,
    width: 21.55,
    height: 140.08,
    transform: "translate(2017.55 1010.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 962,
    y: 450.17,
    width: 21.55,
    height: 125.26,
    transform: "translate(1945.55 1025.61) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 926,
    y: 472.59,
    width: 21.55,
    height: 102.84,
    transform: "translate(1873.54 1048.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 890,
    y: 550.04,
    width: 21.55,
    height: 25.4,
    transform: "translate(1801.54 1125.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 853.99,
    y: 500.71,
    width: 21.55,
    height: 74.73,
    transform: "translate(1729.54 1076.14) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1249.44,
    y: 218.04,
    width: 21.55,
    height: 77.39,
    transform: "translate(2520.42 513.46) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1213.43,
    y: 244.63,
    width: 21.55,
    height: 50.79,
    transform: "translate(2448.42 540.05) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1177.43,
    y: 178.9,
    width: 21.55,
    height: 116.52,
    transform: "translate(2376.41 474.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1141.43,
    y: 267.43,
    width: 21.55,
    height: 27.99,
    transform: "translate(2304.41 562.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1105.43,
    y: 194.48,
    width: 21.55,
    height: 100.94,
    transform: "translate(2232.4 489.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1069.43,
    y: 211.96,
    width: 21.55,
    height: 83.47,
    transform: "translate(2160.4 507.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1033.42,
    y: 230.95,
    width: 21.55,
    height: 64.47,
    transform: "translate(2088.4 526.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 997.42,
    y: 155.34,
    width: 21.55,
    height: 140.08,
    transform: "translate(2016.39 450.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.42,
    y: 170.16,
    width: 21.55,
    height: 125.26,
    transform: "translate(1944.39 465.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 925.42,
    y: 192.58,
    width: 21.55,
    height: 102.84,
    transform: "translate(1872.38 488) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 889.42,
    y: 270.03,
    width: 21.55,
    height: 25.4,
    transform: "translate(1800.38 565.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 853.42,
    y: 220.7,
    width: 21.55,
    height: 74.73,
    transform: "translate(1728.38 516.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M724.65,636.81l751.59-.67A77.88,77.88,0,0,1,1554.07,710l56.44,1089.62a57.42,57.42,0,0,1-56.24,60.38L692.86,1876.4A54.51,54.51,0,0,1,637.32,1822l-1-1096.68A88.37,88.37,0,0,1,724.65,636.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M818.74,1857.93h0l-96.39-1.17a59.61,59.61,0,0,1-58.67-59.32l-.13-145.53a2.22,2.22,0,0,1,2.22-2.22h0a2.22,2.22,0,0,1,2.22,2.22l.13,145.53a55.14,55.14,0,0,0,54.27,54.88l96.39,1.16a2.23,2.23,0,0,1,0,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M665.71,1609.05a2.23,2.23,0,0,1-2.22-2.22l0-23.56a2.23,2.23,0,0,1,2.22-2.23h0a2.22,2.22,0,0,1,2.22,2.22l0,23.57a2.22,2.22,0,0,1-2.22,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M727,628c102.65,13.82,455.63,56.56,747.42,33.9A23.73,23.73,0,0,1,1500,684.24l59.14,1094.48a27.31,27.31,0,0,1-25.64,28.75c-122.72,7.37-628.13,35.89-808.42,17.17a21.65,21.65,0,0,1-19.39-21.4L697.86,653.61A25.66,25.66,0,0,1,727,628Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M738,656.36c98.79,13.3,438.47,54.43,719.27,32.62a22.84,22.84,0,0,1,24.62,21.53l56.92,1053.26a26.3,26.3,0,0,1-24.68,27.67c-118.1,7.09-604.47,34.54-778,16.52a20.83,20.83,0,0,1-18.66-20.59L710,681A24.71,24.71,0,0,1,738,656.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M801.48,762.15,812.17,988a14.35,14.35,0,0,0,13.94,13.68c41.83,1.15,172.15,4.21,245.73.31A16,16,0,0,0,1087,986.44c1.36-42.36,4.32-165.62-5.37-217.14a18.1,18.1,0,0,0-17.19-14.7l-247.2-8.43A15.27,15.27,0,0,0,801.48,762.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 943.79,
    cy: 842.76,
    r: 48.54,
    transform: "translate(-319.49 914.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M870.18,985.35l154.66-.14a12,12,0,0,0,10-18.47c-13.16-20.54-40.67-50.71-88.27-49.31-45.87,1.36-73,28.66-86.69,48.23A12.51,12.51,0,0,0,870.18,985.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1419.86,781.26c4.89,0,8.79-3.42,8.66-7.58s-4.22-7.65-9.11-7.73l-270.91-4.59c-4.89-.08-7.56,3.62-5.93,8.23l1.25,3.53a13.45,13.45,0,0,0,11.84,8.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1148.53,803.46c-4.88-.08-7.55,3.62-5.92,8.23l1.24,3.53a13.47,13.47,0,0,0,11.85,8.37l264.2-.23c4.89,0,8.79-3.42,8.66-7.59s-4.23-7.64-9.11-7.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1148.57,846.17c-4.89-.08-7.55,3.62-5.92,8.23l1.24,3.53a13.47,13.47,0,0,0,11.85,8.37l264.2-.23c4.89,0,8.78-3.42,8.66-7.59s-4.23-7.64-9.12-7.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1446.45,1072c4.89,0,8.66-3.41,8.38-7.58s-4.5-7.6-9.39-7.64l-634.89-4.44c-4.89,0-6.39,3.07-3.34,6.89l5.09,6.38c3.05,3.82,9.54,7,14.43,6.94Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M810.59,1094.45c-4.89,0-6.4,3.06-3.35,6.88l5.1,6.39c3,3.82,9.54,7,14.43,6.94l619.72-.55c4.89,0,8.66-3.42,8.38-7.58s-4.51-7.61-9.39-7.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M893.64,1257.13h-.14l-53.59-.47c-7.75-.06-14.14-5.39-14.88-12.38l-4.75-45a9.91,9.91,0,0,1,2.34-7.47,11.92,11.92,0,0,1,8.31-4.12h0c4.52-.31,10.88-.85,17.62-1.43,14.91-1.29,31.81-2.74,41.74-2.87h.23c7.12,0,13.24,4.34,14.94,10.61,2.81,10.34,2.58,29.89,2.07,50.73C907.36,1251.6,901.14,1257.13,893.64,1257.13Zm-62.4-65a7.47,7.47,0,0,0-5.22,2.53,5.52,5.52,0,0,0-1.32,4.15l4.75,45c.5,4.75,5,8.36,10.49,8.41l53.6.47h.1c5.11,0,9.34-3.6,9.45-8,.5-20.49.74-39.69-1.92-49.46-1.15-4.26-5.62-7.32-10.66-7.32h-.16c-9.77.13-27.32,1.64-41.41,2.85-6.77.58-13.15,1.13-17.7,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M945.15,1210.31c-4.89,0-7.87,3.84-6.62,8.57l2.54,9.59a12,12,0,0,0,11.16,8.49l485.92-5.51a8.8,8.8,0,0,0,8.69-9l0-2.22a9.18,9.18,0,0,0-9.09-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M839.28,1203.68h0a8.22,8.22,0,0,1,11.35,3.08l10.59,18.94a2.64,2.64,0,0,0,4.72-.21l26.17-58.4a2.92,2.92,0,0,1,5.59,1.26c-.25,17.86-5,51.8-33.46,80.24,0,0-15.73-6.1-28.41-33.89A8.62,8.62,0,0,1,839.28,1203.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M893.74,1372h-.13l-53.6-.46c-7.74-.07-14.14-5.4-14.88-12.39l-4.75-45a10,10,0,0,1,2.34-7.47,11.91,11.91,0,0,1,8.31-4.11h0c4.52-.32,10.73-.85,17.58-1.44,14.18-1.22,31.84-2.74,41.78-2.87h.23c7.12,0,13.24,4.34,14.94,10.61,2.81,10.35,2.58,29.9,2.07,50.73C907.46,1366.47,901.24,1372,893.74,1372Zm-3.13-69.27h-.16c-9.78.13-27.35,1.64-41.46,2.86-6.87.59-13.12,1.13-17.65,1.44h0a7.5,7.5,0,0,0-5.22,2.53,5.53,5.53,0,0,0-1.32,4.16l4.75,45c.5,4.75,5,8.36,10.5,8.41l53.59.47h.1c5.11,0,9.34-3.59,9.45-8,.5-20.49.74-39.68-1.91-49.45C900.12,1305.79,895.65,1302.73,890.61,1302.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M837.1,1311.5c11.26-.78,35.73-3.28,47.33-3.44,4.92-.06,9.24,2.9,10.39,7.17,2.25,8.28,2,24.79,1.59,40-.11,4.56-4.3,8.2-9.42,8.16l-42.83-.37c-5.26,0-9.64-3.64-10.13-8.31l-3.8-35.94C829.84,1315.09,832.92,1311.79,837.1,1311.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M945.25,1325.18c-4.89,0-7.87,3.85-6.61,8.57l2.54,9.6a12,12,0,0,0,11.15,8.49l485.93-5.52a8.8,8.8,0,0,0,8.68-9l0-2.23a9.18,9.18,0,0,0-9.09-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M893.84,1486.87h-.13l-53.6-.46c-7.74-.07-14.14-5.4-14.87-12.39l-4.76-45a10,10,0,0,1,2.34-7.48,11.91,11.91,0,0,1,8.31-4.11h0c4.52-.31,10.89-.86,17.63-1.44,14.91-1.28,31.8-2.74,41.73-2.87h.24c7.11,0,13.23,4.33,14.94,10.6,2.8,10.34,2.58,29.9,2.06,50.73C907.57,1481.34,901.35,1486.87,893.84,1486.87Zm-62.4-65a7.49,7.49,0,0,0-5.22,2.54,5.57,5.57,0,0,0-1.32,4.15l4.75,45c.5,4.75,5,8.37,10.5,8.41l53.6.47h.09c5.11,0,9.34-3.59,9.45-8,.51-20.49.74-39.69-1.91-49.45-1.16-4.27-5.63-7.33-10.66-7.33h-.17c-9.77.13-27.31,1.64-41.41,2.86-6.76.58-13.15,1.13-17.7,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M837.2,1426.37c11.26-.77,35.73-3.28,47.33-3.44,4.92-.06,9.24,2.91,10.39,7.17,2.25,8.28,2,24.79,1.59,40-.11,4.56-4.3,8.21-9.41,8.16l-42.83-.37c-5.27-.05-9.65-3.63-10.14-8.31l-3.8-35.93C829.94,1430,833,1426.66,837.2,1426.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M945.35,1440.05c-4.89,0-7.86,3.85-6.61,8.57l2.54,9.6a12,12,0,0,0,11.16,8.49l485.92-5.52a8.79,8.79,0,0,0,8.68-9l0-2.23a9.18,9.18,0,0,0-9.09-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M893.94,1601.75h-.13l-53.6-.47c-7.74-.07-14.14-5.39-14.87-12.39l-4.76-45a10,10,0,0,1,2.34-7.48,12,12,0,0,1,8.31-4.11h0c4.52-.31,10.74-.85,17.58-1.44,14.19-1.22,31.84-2.74,41.78-2.87h.24c7.11,0,13.24,4.33,14.94,10.61,2.81,10.34,2.58,29.89,2.06,50.72C907.67,1596.21,901.45,1601.75,893.94,1601.75Zm-3.12-69.28h-.17c-9.78.13-27.34,1.65-41.46,2.86-6.87.59-13.11,1.13-17.65,1.44h0a7.47,7.47,0,0,0-5.21,2.54,5.55,5.55,0,0,0-1.33,4.15l4.75,45c.51,4.75,5,8.37,10.5,8.42l53.6.46h.09c5.11,0,9.34-3.59,9.45-8,.51-20.48.74-39.68-1.91-49.45C900.32,1535.53,895.85,1532.47,890.82,1532.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M837.3,1541.25c11.26-.78,35.73-3.29,47.34-3.44,4.91-.07,9.23,2.9,10.39,7.16,2.24,8.28,2,24.79,1.59,40-.12,4.56-4.3,8.21-9.42,8.16l-42.83-.37c-5.27,0-9.65-3.63-10.14-8.31l-3.8-35.93C830,1544.83,833.13,1541.54,837.3,1541.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M945.45,1554.92c-4.89,0-7.86,3.85-6.61,8.57l2.54,9.6a12,12,0,0,0,11.16,8.49l485.92-5.52a8.78,8.78,0,0,0,8.68-9l-.05-2.23a9.18,9.18,0,0,0-9.09-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1146.93,487.87c-27.17-18.87-50.77-18.47-67.39-13.55A33.15,33.15,0,0,0,1056,509.18l7.24,78.22,85.28,7.49S1200.2,524.86,1146.93,487.87ZM1109.48,551a21.26,21.26,0,1,1,21.25-21.28A21.26,21.26,0,0,1,1109.48,551Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1071.76,554.65a2.23,2.23,0,0,1-2.22-2l-1.15-12.45a2.22,2.22,0,0,1,4.43-.41l1.15,12.45a2.22,2.22,0,0,1-2,2.42Zm-2.26-24.41a2.21,2.21,0,0,1-2.21-2l-.88-9.45a31.81,31.81,0,0,1,22.52-33.39,63.93,63.93,0,0,1,31.25-1.31,2.22,2.22,0,0,1-.89,4.35,59.58,59.58,0,0,0-29.1,1.22,27.34,27.34,0,0,0-19.35,28.72l.87,9.46a2.22,2.22,0,0,1-2,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M946.93,638.05l0-39.32a24,24,0,0,1,24.8-24l271.15,9a23.34,23.34,0,0,1,22.52,21.91l2.3,37.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1036.32,589.64a2.22,2.22,0,1,1,0-4.44H1048a2.22,2.22,0,1,1,0,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M961.59,625.85a2.21,2.21,0,0,1-2.22-2.22l0-15.9a22.48,22.48,0,0,1,22.44-22.48l42.87,0h0a2.22,2.22,0,1,1,0,4.44l-42.87,0a18,18,0,0,0-18,18v15.91a2.21,2.21,0,0,1-2.22,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M862,623.73l474.15-.43a35.06,35.06,0,0,1,34.56,29l.4,2.32a30.09,30.09,0,0,1-29.62,35.25L855,690.34a19.56,19.56,0,0,1-19.56-20.49l1-21.77A25.57,25.57,0,0,1,862,623.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M325.28,1869.05c29.62,1.36,58.29.5,77.44-.48-17.43-12.41-57.59-39.4-91.2-50.15L288.46,1817s-7.82,11.89-10.61,39.09C281.67,1860.9,292.85,1867.55,325.28,1869.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M403,1868.74l-.24-.17c-19.15,1-47.82,1.84-77.44.48-32.43-1.5-43.61-8.15-47.43-12.92-.13,1.25-.26,2.5-.37,3.82a10.81,10.81,0,0,0,9.93,11.66c24.26,1.84,84.41,6,113.42,4.47A4,4,0,0,0,403,1868.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M113.4,1861.12c-2.17-13.91-5.65-34-8.33-39.15-4.22-8.07-18.65,0-18.65,0s-10.14,4.72-14.8,12.6c-3,5-11.2,19.3-16.77,29A6.45,6.45,0,0,0,54,1867l57.8,2A11.58,11.58,0,0,0,113.4,1861.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M54,1867a6.59,6.59,0,0,0,6.4,6.4l41.18,1.13a11.64,11.64,0,0,0,10.22-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M117.82,1775.74c-.5,1.67-8,37.88-11.24,53.77a9.08,9.08,0,0,1-9.34,7.25c-2.44-.12-5.29-.34-8.27-.73a10.94,10.94,0,0,1-9.53-10.44c-.53-13.92-.79-40.64,4.32-51C90.81,1760.3,117.82,1775.74,117.82,1775.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M283.92,1786.11c3.2-.1-1.28,16.54,3.57,32.9,1.09,3.68,3.85,6.58,7.7,6.63,2.49,0,5.45,0,8.44-.26a9.28,9.28,0,0,0,8.56-8.37l3.94-42.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M373.52,1335.15c-1.43,7-51.9,301.31-55,453.62a5.19,5.19,0,0,1-4.46,5c-6.4.89-18.88,2-31-.21a3.66,3.66,0,0,1-3-3.35c-1.76-28.38-15.95-268.37,1.43-381.34,0,0-143.49,302-165.24,385.26a4.38,4.38,0,0,1-4.48,3.28c-6.15-.33-18.93-1.43-29.07-5.17a7.58,7.58,0,0,1-4.79-8.92c12.15-49.84,97.31-393.17,155.13-468.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M281.54,1410.81a1.89,1.89,0,0,1-1.35-3.2L299.4,1388a1.88,1.88,0,0,1,2.7,2.63l-19.22,19.65A1.87,1.87,0,0,1,281.54,1410.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M547,967.57c-30,7.68-61.48,6.91-91.43-.93-42-11-124.67-29.17-180.95-19L152,1461.47a24.23,24.23,0,0,0,14,27.92c57.61,24.56,114.61,42,169.71,37a23.5,23.5,0,0,0,21.13-21.28l19.49-210.51,88.06-216.62S581.49,1061,644.86,984c-15.43-16.81-27.82-35.47-35.41-48C593.65,949.54,573.29,960.84,547,967.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M678.88,821.12,664,814.59s.74,74.22-54.57,121.45c7.59,12.5,20,31.16,35.41,48C676.09,946.05,694.26,893.48,678.88,821.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M366.89,865.66S355.7,932.4,354.2,953.37c0,0,54,14.92,68.12,6.93l-1.76-80.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M579.92,1044.57A9.91,9.91,0,0,1,590.35,1056l-43.91,275.83a9.89,9.89,0,0,1-9.37,8.34L97.73,1358.56a9.93,9.93,0,0,1-10.32-9.5l-10.91-262a9.92,9.92,0,0,1,9.26-10.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M544.84,1025.62a10.38,10.38,0,0,1,11.3,10.65l-8.95,299.12a10.38,10.38,0,0,1-9.93,10.06l-438,18.3a10.37,10.37,0,0,1-10.74-9.22L58.1,1079.69a10.38,10.38,0,0,1,9.39-11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M501.06,1010.38a12.82,12.82,0,0,1,15,11.41l29.6,309.78a12.83,12.83,0,0,1-12.23,14l-431.38,18a12.83,12.83,0,0,1-13.33-11.91l-18-254.92a12.81,12.81,0,0,1,10.59-13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M321.9,1027.19l-47.28-79.58s-98.88,84.7-128.78,202.5l52.44,33C219.8,1144.63,257.29,1093.46,321.9,1027.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M218.48,1357.86a12.84,12.84,0,0,1-11.4-7.47c-5.37-11.65-15.9-33.86-21.41-41,0,0,6.07-3,16.82-.46s19.85-1.88,20.16-7.85l-50.26-21.54c-1.81-5.13-9.11-33.92,25.89-96.45l-52.44-33c-11.2,44.11-12.75,92.84,4.21,143.52,0,0,9.89,57.56,29.91,69.2s50.47-4.72,50.47-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M427.59,804.14s18,41.25,19.16,62.9,5.87,35.7-19.16,40.06S381.46,899,370,877.42c0,0-17.9-33.23-13.89-46.84S427.59,804.14,427.59,804.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M378.59,861.91h3.17s-13-26.74-1.59-31.44,56.85-14,66.64-30.06c9.44-15.53,1-35.58-11.57-41.19a1.69,1.69,0,0,0-2.15.79l-1,2a1.7,1.7,0,0,1-3.14-.32h0a1.69,1.69,0,0,0-3.05-.46c-3,4.81-11.11,12.64-32.88,16.66-30.89,5.7-51.31,18.2-51.81,39.55a1.7,1.7,0,0,1-2.63,1.39c-2.28-1.39-5.93-2-10.81,2.06-8.48,7.13-5,25.63,13.58,40.85a1.69,1.69,0,0,1-.08,2.73c-3.37,2.19-8.39,7.41,4.63,14.37,13.31,7.12,21.2,6.35,24.17,5.59a1.71,1.71,0,0,0,1.29-1.76l-1.17-18.92a1.71,1.71,0,0,1,1.7-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M379.37,865.87s-6.85-26.35-18.66-19,6.13,29.52,15.62,30.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M662.11,827.77,639.5,784l29.06-76.35s20,10,11.61,27.81,1,37.87,2.07,45.36S692.79,827.05,662.11,827.77Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1311.23,
    cy: 271.84,
    rx: 187.37,
    ry: 181.68,
    transform: "translate(-4.95 25.09) rotate(-1.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 1311.23,
    cy: 271.84,
    rx: 181.14,
    ry: 175.64,
    transform: "translate(-4.95 25.1) rotate(-1.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1144.32,283.84a2.22,2.22,0,0,1-2.22-2.08,160.23,160.23,0,0,1,.06-20.79,2.23,2.23,0,1,1,4.44.3,154.86,154.86,0,0,0-.06,20.21,2.23,2.23,0,0,1-2.08,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1154.38,218a2.23,2.23,0,0,1-2.07-3c22.39-58.57,76-99.35,140-106.41a177.6,177.6,0,0,1,30.66-.71,2.22,2.22,0,0,1-.29,4.44,171.75,171.75,0,0,0-29.89.69c-62.26,6.88-114.48,46.57-136.28,103.58A2.22,2.22,0,0,1,1154.38,218Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1315.6,
    cy: 275.21,
    rx: 153.31,
    ry: 148.65,
    transform: "translate(-5.01 25.17) rotate(-1.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1434.69,192.31c.12,3.79,0,7.56-.28,11.34s-.64,7.55-1.19,11.3a138.18,138.18,0,0,1-5,22.29c-1.18,3.66-2.54,7.26-4.06,10.83a102,102,0,0,1-5.32,10.41,70,70,0,0,1-15.47,18.23l-1.18,1-1.24.9c-.85.6-1.65,1.22-2.53,1.79a51.21,51.21,0,0,1-5.5,3.09l-1.42.69-.72.34-.73.29-2.93,1.13c-1,.39-2,.63-3,.95s-2,.62-3,.81A93.46,93.46,0,0,1,1356.8,290a191.63,191.63,0,0,1-23.73-2.27c-7.78-1.23-15.44-2.77-23-4.41-15.15-3.31-30.06-7.16-44.74-9.85-3.66-.67-7.31-1.22-10.9-1.62l-2.69-.27-2.65-.17c-.87-.08-1.77-.1-2.67-.13s-1.81-.07-2.7-.06a73.17,73.17,0,0,0-20.61,2.49,50,50,0,0,0-9.13,3.65,45.14,45.14,0,0,0-8,5.38,57,57,0,0,0-12.57,15.53c-1.71,3-3.28,6.21-4.73,9.48l-1.05,2.49c-.35.83-.7,1.67-1,2.52l-1,2.55c-.33.85-.61,1.72-.92,2.59-.64,1.72-1.22,3.47-1.79,5.24s-1.11,3.54-1.71,5.32l-1.65,5.4c-.54,1.81-1.06,3.63-1.68,5.45h0a.39.39,0,0,1-.5.25.4.4,0,0,1-.28-.33c-.23-1.91-.39-3.82-.53-5.74s-.18-3.84-.19-5.76a107,107,0,0,1,.54-11.57,101.12,101.12,0,0,1,1.88-11.58,82.93,82.93,0,0,1,3.58-11.43,66.79,66.79,0,0,1,5.66-11c.58-.87,1.2-1.73,1.8-2.6l2-2.5a50.08,50.08,0,0,1,4.41-4.7,54.42,54.42,0,0,1,22.6-12.58,87.9,87.9,0,0,1,24.92-3c1,0,2,0,3.06.08s2,.07,3.08.16l3.1.25,3,.35c4,.5,8,1.16,11.88,1.93,7.79,1.51,15.37,3.33,22.86,5.25l22.3,5.67c7.39,1.85,14.76,3.58,22.14,5a182.46,182.46,0,0,0,22,3,84.8,84.8,0,0,0,21.49-.91c.88-.12,1.71-.35,2.56-.55s1.72-.37,2.53-.64l2.46-.79.62-.19.59-.25,1.18-.49a43.18,43.18,0,0,0,4.6-2.21c.74-.42,1.47-.92,2.21-1.38l1.11-.69,1-.78a57.33,57.33,0,0,0,8-6.9,75.56,75.56,0,0,0,6.82-8.26,95.6,95.6,0,0,0,5.74-9.23c1.71-3.22,3.29-6.52,4.71-9.91s2.68-6.86,3.86-10.37,2.18-7.08,3.09-10.68a171.68,171.68,0,0,0,4.09-22v0a.39.39,0,0,1,.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1331.92,282.61l-.12-.17-22.2-35.83a1.89,1.89,0,0,1,.66-2.63,2,2,0,0,1,2.7.67l22.2,35.83a1.88,1.88,0,0,1-.66,2.63A2,2,0,0,1,1331.92,282.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1356.46,285.44l-.08-.12L1317,225.6a1.88,1.88,0,0,1,.58-2.65,2,2,0,0,1,2.72.59l39.38,59.72a1.89,1.89,0,0,1-.58,2.65A2,2,0,0,1,1356.46,285.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1320.57,202.92a1.92,1.92,0,0,1,.33-2.74,2,2,0,0,1,2.79.44l61.38,78.89h0a1.92,1.92,0,0,1-.33,2.74,2,2,0,0,1-2.79-.44l-61.38-78.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1330.17,187.29a1.89,1.89,0,0,1,.35-2.66,2,2,0,0,1,2.76.34l69.57,86.41a1.89,1.89,0,0,1-.32,2.7,2,2,0,0,1-2.76-.34l-69.57-86.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1411.45,261.4l0,0-65.08-88.05a1.88,1.88,0,0,1,.43-2.68,2,2,0,0,1,2.74.45l65.08,88.06a1.87,1.87,0,0,1-.43,2.67A2,2,0,0,1,1411.45,261.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1421.69,243.21l0-.05-56-77.15a1.88,1.88,0,0,1,.46-2.67,2,2,0,0,1,2.74.47l56,77.15a1.9,1.9,0,0,1-.46,2.68A2,2,0,0,1,1421.69,243.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1426.64,223.38a.44.44,0,0,1-.08-.11l-38.92-58.77a1.88,1.88,0,0,1,.59-2.62,2,2,0,0,1,2.69.54l38.92,58.78a1.86,1.86,0,0,1-.6,2.61A2,2,0,0,1,1426.64,223.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1247,265.57a1.89,1.89,0,0,1,.14-2.48,2,2,0,0,1,2.78,0l53.06,49.68a1.88,1.88,0,0,1,.07,2.71,2,2,0,0,1-2.77.05l-53.06-49.68A1.7,1.7,0,0,1,1247,265.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1229.79,265.76a1.88,1.88,0,0,1,.29-2.62,2,2,0,0,1,2.77.25l62.6,72.6a1.87,1.87,0,0,1-.23,2.7,2,2,0,0,1-2.77-.24l-62.6-72.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1212.06,270.5a1.89,1.89,0,0,1,.34-2.67,2,2,0,0,1,2.76.34l71.95,89.45a1.87,1.87,0,0,1-.32,2.69A2,2,0,0,1,1284,360l-72-89.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1267.85,376.18l0,0s-17.69-23.81-35.34-47.66c-10.25-13.85-18.41-24.89-24.25-32.82-3.3-4.49-6-8.23-8-10.86l-2.22-3.08c-.91-1.3-1.71-2.42-.53-3.56a2,2,0,0,1,2.77,0,1.77,1.77,0,0,1,.39.53c2.24,3.46,51.41,69.75,70.32,95.2a1.89,1.89,0,0,1-.43,2.68A2,2,0,0,1,1267.85,376.18Zm-67.22-95.71a1.8,1.8,0,0,1-.32.42A1.8,1.8,0,0,0,1200.63,280.47Zm.11-1.62a2,2,0,0,1,.14.6A1.88,1.88,0,0,0,1200.74,278.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1245.08,383.68a1.63,1.63,0,0,0-.11-.17l-57.34-92a1.88,1.88,0,0,1,.64-2.63,2,2,0,0,1,2.71.66l57.34,92a1.87,1.87,0,0,1-.65,2.63A2,2,0,0,1,1245.08,383.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1215.41,387.11a2.16,2.16,0,0,1-.22-.36l-34.92-74.28a1.9,1.9,0,0,1,1-2.54,2,2,0,0,1,2.61,1l34.92,74.28a1.9,1.9,0,0,1-1,2.54A2,2,0,0,1,1215.41,387.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1420.41,170.42a141.4,141.4,0,0,0-23.47-3.38,101.33,101.33,0,0,0-23,1.07,73.19,73.19,0,0,0-10.85,2.68,63.27,63.27,0,0,0-10,4.35,55.62,55.62,0,0,0-8.92,6.07,56.49,56.49,0,0,0-7.63,7.6,70.77,70.77,0,0,0-11.13,18.74c-.74,1.7-1.34,3.45-2,5.19s-1.18,3.53-1.68,5.33c-1.07,3.57-1.9,7.24-2.66,10.93-.33,1.86-.72,3.7-1,5.58l-.44,2.8-.4,2.89-1.58,11.58-3.13,23.21c-2.19,15.49-4.42,31.06-8.14,46.52a157.11,157.11,0,0,1-7.17,22.9,78.74,78.74,0,0,1-12.41,21.07,59.32,59.32,0,0,1-19.59,15.15,80.19,80.19,0,0,1-23.62,6.75,139.68,139.68,0,0,1-24.24,1c-4-.15-8-.4-12-.81s-8-.86-12-1.41a.38.38,0,0,1-.34-.43.39.39,0,0,1,.41-.33c8,.4,16,.57,23.9.31,4-.12,7.92-.4,11.85-.79s7.81-1,11.64-1.74a75.1,75.1,0,0,0,21.72-7.53,53.4,53.4,0,0,0,16.92-14.37,75.18,75.18,0,0,0,10.46-19.7,151.5,151.5,0,0,0,6.08-22c1.55-7.52,2.71-15.15,3.8-22.82s2-15.39,2.92-23.12l2.74-23.26q.69-5.82,1.43-11.65l.37-2.91.43-3c.26-2,.66-4,1-6,.77-4,1.63-7.93,2.76-11.84.52-2,1.2-3.9,1.81-5.85s1.37-3.86,2.19-5.76a80.51,80.51,0,0,1,12.71-21.49,65.51,65.51,0,0,1,9.16-8.92,61.63,61.63,0,0,1,10.9-6.88,67.57,67.57,0,0,1,24.61-6.52,87.73,87.73,0,0,1,24.85,1.8,97.34,97.34,0,0,1,11.83,3.33,76.62,76.62,0,0,1,11.2,4.84.37.37,0,0,1,.15.52.38.38,0,0,1-.43.19Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1647.16,
    cy: 1172.29,
    rx: 174.98,
    ry: 185.3,
    transform: "translate(-121.56 192.99) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 1647.16,
    cy: 1172.29,
    rx: 169.16,
    ry: 179.14,
    transform: "translate(-121.56 192.98) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1491.23,1183.36a2.22,2.22,0,0,1-2.22-2.08,180,180,0,0,1-.08-21.16,2.22,2.22,0,1,1,4.43.25,173.22,173.22,0,0,0,.09,20.63,2.23,2.23,0,0,1-2.08,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1500.18,1116.29a2.27,2.27,0,0,1-.72-.12,2.23,2.23,0,0,1-1.38-2.83c20.53-59.57,70.43-100.79,130.21-107.56a150.6,150.6,0,0,1,28.71-.52,2.23,2.23,0,0,1,2,2.39,2.27,2.27,0,0,1-2.39,2,146.71,146.71,0,0,0-27.87.5c-58.07,6.58-106.54,46.66-126.51,104.6A2.23,2.23,0,0,1,1500.18,1116.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1651.9,
    cy: 1181.39,
    rx: 143.17,
    ry: 157.29,
    transform: "translate(-122.56 193.59) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1672.46,1093.78l-.08-49.27h-44.85l.08,46.3a115.63,115.63,0,0,1-22.77,68.91l-59.07,79.64a24.14,24.14,0,0,0-4.76,14.39v0a24.15,24.15,0,0,0,24.15,24.15h170.23a24.15,24.15,0,0,0,24.15-24.15h0a24.13,24.13,0,0,0-4.79-14.43l-61.21-82.07A106.16,106.16,0,0,1,1672.46,1093.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1565.16,1271.89a18.13,18.13,0,0,1-18.11-18.11,18.31,18.31,0,0,1,3.56-10.82l59.08-79.64a122.53,122.53,0,0,0,24-72.51l-.07-40.26h32.77l.08,43.24a113,113,0,0,0,22.27,67.1l61.21,82.07a18.11,18.11,0,0,1-14.52,28.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1673.72,1053.37h-47.45a7,7,0,0,1-7-6.95h0a7,7,0,0,1,6.57-6.93l47.46-2.55a6.94,6.94,0,0,1,7.31,6.93v2.55A7,7,0,0,1,1673.72,1053.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1550.61,1243a18.31,18.31,0,0,0-3.56,10.82,18.13,18.13,0,0,0,18.11,18.11h170.23a18.11,18.11,0,0,0,14.52-28.93l-27.34-36.65H1577.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1617.4,
    cy: 641.04,
    rx: 208.79,
    ry: 221.11,
    transform: "translate(-61.91 186.26) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 1617.4,
    cy: 641.04,
    rx: 201.85,
    ry: 213.75,
    transform: "translate(-61.91 186.25) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1431.33,653.82a2.22,2.22,0,0,1-2.21-2.08,211.91,211.91,0,0,1-.1-25.2,2.22,2.22,0,1,1,4.43.25,209.36,209.36,0,0,0,.1,24.67,2.22,2.22,0,0,1-2.07,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1442,573.78a2.37,2.37,0,0,1-.73-.12,2.22,2.22,0,0,1-1.37-2.82c24.44-70.93,83.84-120,155-128.07a180,180,0,0,1,34.18-.61,2.22,2.22,0,0,1-.35,4.43,175.33,175.33,0,0,0-33.34.6C1526,455.06,1468,503,1444.12,572.29A2.22,2.22,0,0,1,1442,573.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1622.29,
    cy: 645.18,
    rx: 170.84,
    ry: 180.92,
    transform: "translate(-62.35 186.84) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1730.35,571.19H1678V518.8a24.69,24.69,0,0,0-24.69-24.7h-73.47a24.69,24.69,0,0,0-24.69,24.7v52.39h-52.39A24.68,24.68,0,0,0,1478,595.88v73.47A24.68,24.68,0,0,0,1502.71,694h52.39v52.4a24.69,24.69,0,0,0,24.69,24.69h73.47A24.69,24.69,0,0,0,1678,746.44V694h52.4A24.69,24.69,0,0,0,1755,669.35V595.88A24.69,24.69,0,0,0,1730.35,571.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1579.79,756.55a10.13,10.13,0,0,1-10.11-10.11v-67h-67a10.11,10.11,0,0,1-10.11-10.11V595.88a10.12,10.12,0,0,1,10.11-10.11h67v-67a10.13,10.13,0,0,1,10.11-10.12h73.47a10.12,10.12,0,0,1,10.11,10.12v67h67a10.13,10.13,0,0,1,10.11,10.11v73.47a10.12,10.12,0,0,1-10.11,10.11h-67v67a10.12,10.12,0,0,1-10.11,10.11Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthImg2);
export default __webpack_public_path__ + "static/media/health_img_2.bf400480e327c1a2bd505055f4b21539.svg";
export { ForwardRef as ReactComponent };